import DateIcon from '@mui/icons-material/DateRangeOutlined';
import {Box, Button} from '@mui/material';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import React, {useState} from 'react';

function ButtonField(props) {
  const {
    setOpen,
    value,
    id,
    disabled,
    InputProps: {ref} = {},
    inputProps: {'aria-label': ariaLabel} = {},
  } = props;

  return (
    <Button
      variant="standard"
      id={id}
      disabled={disabled}
      ref={ref}
      aria-label={ariaLabel}
      onClick={() => setOpen?.(prev => !prev)}
    >
      {value.utc().format('YYYY-MM-DD')}
    </Button>
  );
}

ButtonField.propTypes = {
  setOpen: PropTypes.func,
  value: PropTypes.object,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  InputProps: PropTypes.shape({
    ref: PropTypes.any,
  }),
  inputProps: PropTypes.shape({
    'aria-label': PropTypes.string,
  }),
};

function ButtonDatePicker(props) {
  const [open, setOpen] = useState(false);

  return (
    <DatePicker
      slots={{field: ButtonField, ...props.slots}}
      slotProps={{field: {setOpen}}}
      timezone="UTC"
      {...props}
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
    />
  );
}

ButtonDatePicker.propTypes = {
  slots: PropTypes.object,
};

function IntervalChooser({handleChange, range, minDate, maxDate}) {
  const startDate = range[0];
  const endDate = range[1];

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <DateIcon />
      <ButtonDatePicker
        format="yyyy-MM-dd"
        mask="____-__-__"
        minDate={dayjs(minDate)}
        maxDate={dayjs(maxDate)}
        value={dayjs(startDate)}
        onChange={nextStartDate => {
          if (!nextStartDate) {
            handleChange([minDate, endDate]);
          } else {
            handleChange([nextStartDate.toDate(), endDate]);
          }
        }}
      />
      -
      <ButtonDatePicker
        format="yyyy-MM-dd"
        mask="____-__-__"
        minDate={dayjs(minDate)}
        maxDate={dayjs(maxDate)}
        value={dayjs(endDate)}
        onChange={nextEndDate => {
          if (!nextEndDate) {
            handleChange([startDate, maxDate]);
          } else {
            handleChange([startDate, nextEndDate.toDate()]);
          }
        }}
      />
    </Box>
  );
}

IntervalChooser.propTypes = {
  range: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  handleChange: PropTypes.func.isRequired,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date),
};

export default IntervalChooser;
